<div [ngStyle]="{ 'display' : crossSectionController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.crossSectionController.loading? 'active' : ''">
    <div></div>
  </div>

  <form id="ngCrossSectionController"
    [ngClass]="[this.crossSectionController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    name="ngCrossSectionController" #ngCrossSectionController="ngForm" id="CrossSectionForm" style="height: 600px">
    <div class="fields__block" style="width: 100%;">
      <div class="fields__block__section">
        <div class="title">
          <h4>Cross Section Graph</h4>
          <span> </span>
        </div>
        <canvas id="crossSectionCanvas" style="max-height: 270px;"></canvas>
      </div>

      <div class="fields__block__section">
        <div>
          <span class="block text-bold mb-2">
            Section # - [a, b]
          </span>
          <div>
            <ul style="list-style-type:lower-alpha;margin-left: 15px;">
              <li>
                <p>
                  Terrain Height to see last point from origin of section
                </p>
              </li>
              <li>
                <p>
                  Terrain Height to see first point from end of section
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
